import { DataTypeProvider } from '@devexpress/dx-react-grid';
import NROutOfDateIcon from '../../../NRIcons/NROutOfDateIcon';
import { NRHandleEmptyCellValue } from '../CellComponent/CellComponent';
import NRValueTooltipIcon from './NRValueTooltipIcon';

const SBOMVersionFormatter = ({ value, column, row }) => {
  // const attrToCheck = 'versionDate'; // Enable this again when we have BE support
  const isOutOfDate = false; // row[attrToCheck]; // Enable this again when we have BE support

  return (
    <NRValueTooltipIcon
      value={<NRHandleEmptyCellValue value={value} />}
      icon={isOutOfDate ? <NROutOfDateIcon /> : null}
      tooltip={isOutOfDate ? 'Version out of date' : null}
    />
  );
};
export const NRSBOMVersionProvider = props => <DataTypeProvider formatterComponent={SBOMVersionFormatter} {...props} />;
